import {configureStore} from '@reduxjs/toolkit';
import sharedReducer from './shared';

export default configureStore({
    reducer: {
        shared: sharedReducer
    },
})
